module.exports = __webpack_public_path__ + "static/media/22-2.8b575b21.mp3";